export default __webpack_public_path__ + "static/media/qana-project-3.4994ff5d.jpg";